// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#dropdown-variant {\n  padding: 8px;\n  background-color: #007bff;\n}", "",{"version":3,"sources":["webpack://./src/app/pages/Chatbots/botDetails/botDetail.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,yBAAA;AACF","sourcesContent":["#dropdown-variant{\r\n  padding:8px;\r\n  background-color: #007bff;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
